<template>
	<div class="company-location-card-edit">
		<Input label="Location Name" v-model="localData.name" />
		<Input label="Location Nickname" v-model="localData.nickname" />
		<Dropdown
			label="Parts Location Sourced From *"
			v-model="localData.source"
			:options="sourceTypeOptions"
		/>
	</div>
</template>

<script>
import Input from '@/components/forms/input/input';
import Dropdown from '@/components/forms/dropdown/dropdown.vue';
import _ from 'lodash';

export default {
	name: 'CompanyLocationCardEdit',
	components: { Input, Dropdown },
	props: {
		value: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			localData: _.cloneDeep(this.value),
			sourceTypeOptions: ['primary', 'secondary']
		};
	},
	created() {
		// console.log(this.value);
	},
	watch: {
		localData: {
			deep: true,
			handler() {
				this.$emit('update', this.localData);
				this.$emit('input', this.localData);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@/scss/5-objects/_cards.scss';

.company-information-card-edit {
	@include card;

	&__item {
		display: block;
	}
}
</style>
